import { GetProp, Avatar, Button,Card, Col, Divider, Row, Space, Typography, Upload, UploadFile, UploadProps } from "antd";
import React, { useEffect, useState } from "react";
import { Input } from 'antd';
import { PaperClipOutlined} from '@ant-design/icons';
import StringList from "components/string-list";
import { PrepaidCommentDTO } from "./dto/prepaid-comment.dto";
import config from 'config';
import useToastContext from '../../hooks/useToastContext';
import useUploadImporterFile from "hooks/useUploadImporter";
import { HttpStatusCode } from '../../constants';

const { Text } = Typography;
const { TextArea } = Input;

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

 
 
interface PrepaidCommentCreatorProps {
    user: string;  // Ensure items is a string array
    loading: boolean;
    onCreate?: (item: PrepaidCommentDTO) => void;
    clearForm?: () => void;
  }
 
const PrepaidCommentCreator: React.FC<PrepaidCommentCreatorProps> = ({user, loading, onCreate, clearForm}) => {
  const toast = useToastContext();
  const [value, setValue] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [stringList, setStringList] = useState<string[]>([]);
  const { upload, isLoading } = useUploadImporterFile()

    // Sync fileList to stringList
    useEffect(() => {
      setStringList(fileList.map((file) => file.name)); // Extract file names
    }, [fileList]);
  
      // Handle file upload changes
    const handleChange = ({ fileList: newFileList }: { fileList: UploadFile[] }) => {
       setFileList(newFileList);
     };
  
        // Remove file from both lists
    const handleRemove = (fileName: string) => {
      const newFileList = fileList.filter((file) => file.name !== fileName);
      setFileList(newFileList); // Update fileList → stringList auto-updates
    };
  

  const props: UploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      setFileList([file]);

      return false;
    },
    fileList,
  };


  const submitComment = async (comment: string) => {
    if(fileList !== undefined && fileList.length > 0) {
      const formData = new FormData();
      formData.append('file', (fileList[0] as any).originFileObj);

      try {
        const res = await upload( "CLAIMS_LOAD" , formData);
        if ([HttpStatusCode.NoContent, HttpStatusCode.Ok].includes(res.status)) {
          toast.success('Archivo subido', `El archivo se subio correctamente`);
          onCreate(new PrepaidCommentDTO(comment, [res?.data?.filename]));
          setFileList([]);

          } else {
            throw new Error('Hubo en error al subir el archivo.');
          }
        } catch (e) {
          setFileList([]);
          console.error(e);
          toast.error('Algo Salio mal', 'Hubo en error al subir el archivo.');
        }
    } else {
      onCreate(new PrepaidCommentDTO(comment, []));
    }
  };

   
  return (
    <Row style={{padding: '1em 0em 0em 0em'}}>
        <Col span="1" style={{ textAlign: 'center'}}>
            <Avatar style={{ backgroundColor: '#a368fc', verticalAlign: 'middle' }}>
                {user.charAt(0).toUpperCase()}
            </Avatar>
        </Col>
 
        <Col flex="auto" style={{paddingLeft: '0.5em'}}>
            <Space  style={{ display: "flex", justifyContent: "space-between", width: '100%', alignItems:'start'}}>
                <Text type="secondary" strong> {user.toUpperCase()} </Text>
                <Upload {...props} style={{verticalAlign: 'super'}}  onChange={handleChange}>
                    <Button
                      disabled={fileList?.length === 1}
                      icon={ <PaperClipOutlined />}
                      size="small"
                      type="link"
                      style={{verticalAlign: 'super'}}
                    >Adjuntar archivos</Button>
                </Upload>
            </Space>
            <>
            <TextArea
                placeholder={"Nuevo comentario..."}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                autoSize={{ minRows: 3 , maxRows: 6 }}
            />
 
            <StringList items={stringList}  onRemove={handleRemove} title="Archivos Adjuntos "/>
 
            <Space style={{marginTop:'1em', display: "flex", justifyContent: "flex-end", width: '100%'}}>
              <Button
                disabled={value === ''}
                type="primary"
                onClick={() => {
                  submitComment(value)
                  setValue('');
                  setStringList([]);
                }}
                style={{ marginRight: '10px' }}
                loading={loading}
              >
                Guardar
              </Button>

            </Space>
            </>            
        </Col>
    </Row>
  )};
 
export default PrepaidCommentCreator